module["exports"] = ["연구소", "게임즈", "그룹", "전자", "물산", "코리아"];